import { colors } from './colors';

export const focus = {
  outline: `2px solid ${colors.brand.secondary}`,
  boxShadow: `0 0 0 2px ${colors.brand.secondary}`,
};
